import { useEffect, useLayoutEffect, useRef } from 'react';
import { MIRRORS_THEMES } from 'themes';

import { MirrorService } from 'services/MirrorService';

export const useMirrorTheme = (variables: Record<string, string>) => {
  const rootRef = useRef<any>(null);

  useEffect(() => {
    Object.entries(variables).forEach(([varName, varValue]) => {
      if (rootRef.current) {
        rootRef.current.style.setProperty(varName, varValue);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootRef.current]);

  return rootRef;
};

export const useMirrorThemeColors = () => {
  useLayoutEffect(() => {
    const currentThemeColors = MIRRORS_THEMES[MirrorService.domain];

    if (currentThemeColors) {
      Object.entries(currentThemeColors).forEach(([name, value]) => {
        document.body.style.setProperty(`--${name}`, value);
      });
    }
  }, []);
};
